<template>
  <div>
    <!-- Selected checklist templates as list (similar to line items) -->
    <q-list v-if="checklistTemplateIds && checklistTemplateIds.length > 0" separator>
      <q-item-wrapper
        v-for="template in selectedTemplates"
        :key="template.id"
      >
        <div class="row items-center">
          <div class="col">
            <q-item-label class="text-bold">
              {{ template.name }}
              <span
                v-if="template.version"
                class="text-caption text-grey-6 q-ml-xs"
              >v{{ template.version }}</span>
            </q-item-label>
            <q-item-label caption>
              {{ (template.items || []).length }} {{ (template.items || []).length === 1 ? 'item' : 'items' }}
            </q-item-label>
          </div>
        </div>

        <template #after>
          <q-item-section side @click.stop>
            <cancel-button
              flat
              @click="removeTemplate(template.id)"
            />
          </q-item-section>
        </template>
      </q-item-wrapper>
    </q-list>
    <div v-else class="text-caption text-grey q-px-md q-py-sm">
      No checklist templates selected
    </div>

    <!-- Add checklist template button (similar to clickable-item) -->
    <clickable-item
      label="Add checklist template..."
      @click="openSelector"
    />

    <!-- Checklist template selector dialog -->
    <SelectChecklistDialog
      v-model="dialogOpen"
      :selected-ids="checklistTemplateIds || []"
      @selected="onTemplatesSelected"
    />
  </div>
</template>

<script>
import SelectChecklistDialog from 'components/app/settings/company/checklistTemplates/partials/SelectChecklistDialog.vue'

export default {
  components: {
    SelectChecklistDialog
  },
  props: {
    checklistTemplateIds: {
      type: Array,
      default: () => []
    },
    checklistTemplates: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:checklistTemplateIds', 'update:checklistTemplates'],
  data () {
    return {
      dialogOpen: false
    }
  },
  computed: {
    selectedTemplates () {
      // Use checklistTemplates if available (from API), otherwise use empty array
      return this.checklistTemplates || []
    }
  },
  methods: {
    openSelector () {
      this.dialogOpen = true
    },
    onTemplatesSelected (templates) {
      const newIds = templates.map(t => t.id)
      this.$emit('update:checklistTemplateIds', newIds)
      this.$emit('update:checklistTemplates', templates)
    },
    removeTemplate (templateId) {
      const currentIds = this.checklistTemplateIds || []
      this.$emit('update:checklistTemplateIds', currentIds.filter(id => id !== templateId))
      const currentTemplates = this.checklistTemplates || []
      this.$emit('update:checklistTemplates', currentTemplates.filter(t => t.id !== templateId))
    }
  }
}
</script>
